/** Debug overlay visualizing the ring-buffer search-memory positions for each enemy. */
import Phaser from 'phaser';
import { Enemy } from '../../entities/Enemy';
import { SEARCH_MEMORY_DIST_SQ } from '../../ai/constants';

const SEARCH_MARKER_SIZE = 4;
const SEARCH_MARKER_COLOR = 0xff8800;
const SEARCH_MARKER_ALPHA = 0.7;
const SEARCH_EXCLUSION_ALPHA = 0.08;
const SEARCH_EXCLUSION_BORDER_ALPHA = 0.15;

/** Draws exclusion-radius circles and cross markers for each enemy's search memory positions. */
export class SearchMemoryOverlay {
  /** Draw search memory markers for all enemies with non-empty memory. */
  draw(graphics: Phaser.GameObjects.Graphics, enemies: readonly Enemy[]): void {
    const exclusionRadius = Math.sqrt(SEARCH_MEMORY_DIST_SQ);

    for (const enemy of enemies) {
      const memory = enemy.ai.searchMemory;
      if (memory.length === 0) continue;

      for (const pos of memory) {
        graphics.fillStyle(SEARCH_MARKER_COLOR, SEARCH_EXCLUSION_ALPHA);
        graphics.fillCircle(pos.x, pos.y, exclusionRadius);
        graphics.lineStyle(1, SEARCH_MARKER_COLOR, SEARCH_EXCLUSION_BORDER_ALPHA);
        graphics.strokeCircle(pos.x, pos.y, exclusionRadius);

        graphics.lineStyle(1.5, SEARCH_MARKER_COLOR, SEARCH_MARKER_ALPHA);
        graphics.beginPath();
        graphics.moveTo(pos.x - SEARCH_MARKER_SIZE, pos.y - SEARCH_MARKER_SIZE);
        graphics.lineTo(pos.x + SEARCH_MARKER_SIZE, pos.y + SEARCH_MARKER_SIZE);
        graphics.strokePath();
        graphics.beginPath();
        graphics.moveTo(pos.x + SEARCH_MARKER_SIZE, pos.y - SEARCH_MARKER_SIZE);
        graphics.lineTo(pos.x - SEARCH_MARKER_SIZE, pos.y + SEARCH_MARKER_SIZE);
        graphics.strokePath();
      }
    }
  }

  clear(): void { /* graphics-only */ }
  destroy(): void { /* nothing to clean up */ }
}
